<template>
  <div class="consultWrap" v-if="customerService?.kfWechatQrcodeUrl?.url || customerService?.kfWhatsappQrcodeUrl?.url">
    <el-popover placement="left-end" trigger="hover">
      <div class="imgList">
        <div class="imgWrap">
          <img :src="customerService.kfWechatQrcodeUrl.url" alt="" />
        </div>
        <div class="imgWrap">
          <img :src="customerService.kfWhatsappQrcodeUrl.url" alt="" />
        </div>
      </div>
      <img src="@/assets/img/icon/consult.png" alt="" slot="reference" />
    </el-popover>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
export default {
  data() {
    return {
      customerService: {
        kfWechatQrcodeUrl: {
          url: null,
        },
        kfWhatsappQrcodeUrl: {
          url: null,
        },
      },
    };
  },
  methods: {
    // 获取客服二维码
    getCustomerService() {
      getAction("/stCustomPage/detail")
        .then(res => {
          const resData = res.data;
          this.customerService = resData;
        })
        .catch(err => {});
    },
  },
  created() {
    // 获取客服二维码
    this.getCustomerService();
  },
};
</script>

<style lang="scss" scoped>
.consultWrap {
  position: fixed;
  bottom: 100px;
  right: 15px;
}

::v-deep {
  .imgWrap:first-child {
    border-top: none;
    padding-top: 0px;
  }

  .imgWrap:last-child {
    padding-bottom: 0px;
  }

  .imgWrap {
    width: 200px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top: 1px solid #ebeef5;

    img {
      width: 100%;
    }
  }
}
</style>
